<template>
  <div class="menu-utilisateur">
    <WrapperForm
      v-model="selectedTab"
      :tabs
    >
      <router-view />
    </WrapperForm>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import type { RouteName } from '@/router/route-name'
  import { useNavigationTabs } from '@/features/interface/profil-utilisateur/useProfilUtilisateurNavigation'

  const route = useRoute()

  const { tabs, goToTab } = useNavigationTabs(['Profil', 'Contacts', 'Rattachements', 'Administration'])

  const selectedTab = computed<RouteName>({
    get: () => route.name as RouteName,
    set: (routeName) => {
      if (route.name !== routeName) {
        goToTab(routeName)
      }
    },
  })
</script>
<style scoped lang="less">
  .menu-utilisateur {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
</style>
